import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  HostListener,
} from "@angular/core";
import * as echarts from "echarts";
import {
  LogicalExtendedDeviceWidgetEnum,
  ModalWidgetEnum,
} from "../../../../enums/widget";
import {
  ChartFeed,
  DateTimeIntervalEntity,
  ExtendedDeviceChartEntity,
  ModalWidget,
} from "../../../../entities";
import { LogicalWidgetEventStruct } from "../../logical";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";

declare var ResizeObserver: any;

@Component({
  selector: "extended-device-chart-logical-widget",
  template: `
    <ng-template #dataSource let-source>
      <div class="btn-group mr-1 ml-1">
        <button
          class="btn"
          type="button"
          [ngClass]="{
            'btn-success': selectedFeed && selectedFeed.key == source.key,
            'btn-info': !(selectedFeed && selectedFeed.key == source.key)
          }"
          (click)="select($event, source.key)"
        >
          {{ source.name }}
        </button>
        <button
          class="btn"
          type="button"
          [ngClass]="{
            'btn-success': selectedFeed && selectedFeed.key == source.key,
            'btn-info': !(selectedFeed && selectedFeed.key == source.key)
          }"
          (click)="remove($event, source.key)"
        >
          <i class="fa fa-minus-circle"></i>
        </button>
      </div>
    </ng-template>

    <ng-template #graphSource let-source>
      <div class="btn-group mr-2 mb-2">
        <button
          class="btn"
          type="button"
          [ngClass]="{
            'btn-success': selected[source.key],
            'btn-info': !selected[source.key]
          }"
          (click)="toggleGraph($event, source.key)"
        >
          {{ source.name }}
        </button>
        <button
          class="btn btn-primary"
          (click)="fetchAndRefresh($event, source.key)"
        >
          <i class="fa fa-plus-circle"></i>
        </button>
      </div>
    </ng-template>

    <ng-container [ngSwitch]="layout">
      <!-- ===================================== -->
      <!-- Default (Card)                        -->
      <!-- ===================================== -->
      <ng-container *ngSwitchDefault>
        <div class="extended-device-chart-logical-widget card">
          <div class="card-header">Feed</div>
          <div class="card-body">
            <div class="d-flex flex-wrap align-items-center mb-4">
              <div class="mr-2 mb-2" style="min-width: 130px;">
                <select
                  class="form-control"
                  name="aggregate"
                  [(ngModel)]="time_period"
                >
                  <option
                    *ngFor="let entry of time_options"
                    value="{{ entry.value }}"
                  >
                    {{ entry.text }}
                  </option>
                </select>
              </div>
              <div class="mr-2 mb-2" style="min-width: 170px;" *ngIf="entity">
                <select
                  class="form-control"
                  name="timezone"
                  [(ngModel)]="time_zone"
                >
                  <option
                    *ngFor="let entry of time_zone_options"
                    value="{{ entry.value }}"
                  >
                    {{ entry.text }}
                  </option>
                </select>
              </div>
              <div class="mr-2 mb-2" style="min-width: 170px;" *ngIf="entity">
                <select
                  class="form-control"
                  name="field"
                  [(ngModel)]="for_field"
                >
                  <option
                    *ngFor="let entry of field_options"
                    value="{{ entry.value }}"
                  >
                    {{ entry.text }}
                  </option>
                </select>
              </div>

              <div class="mr-2 mb-2 d-flex align-items-center bg-light border rounded px-2" style="height: 38px;">
                <label class="switch switch-3d switch-primary mb-0 mr-2">
                  <input
                    class="switch-input switch-primary"
                    [(ngModel)]="metric_units"
                    type="checkbox"
                  />
                  <span class="switch-slider"></span>
                </label>
                <span class="small font-weight-bold text-dark">
                  {{ metric_units ? 'Metric' : 'Imperial' }}
                </span>
              </div>

              <div class="mr-2 mb-2">
                <button
                  class="btn btn-primary d-inline-flex align-items-center"
                  style="height: 38px;"
                  (click)="addRange($event)"
                  title="Add Feed"
                >
                  <i class="fa fa-plus-circle mr-1"></i> Add Feed
                </button>
              </div>

              <div class="mb-2">
                <button
                  class="btn btn-outline-success d-inline-flex align-items-center"
                  style="height: 38px;"
                  (click)="customRange($event, chartModal)"
                  title="Pick Date Range"
                >
                  <i class="fa fa-calendar mr-1"></i> Date Range
                </button>
              </div>
            </div>

            <div class="row" *ngIf="entity">
              <tabset #view class="col">
                <tab heading="Table View">
                  <div class="row" *ngIf="entity">
                    <div class="col">
                      <ng-container
                        *ngFor="let source of objectValues(entity.feeds)"
                      >
                        <ng-container
                          *ngTemplateOutlet="
                            dataSource;
                            context: { $implicit: source }
                          "
                        ></ng-container>
                      </ng-container>
                    </div>
                  </div>

                  <ng-container *ngIf="selectedFeed">
                    <div class="row mt-4">
                      <div class="col">
                        <h1>
                          {{ selectedFeed.name }} ({{ selectedFeed.units }})
                        </h1>
                      </div>
                    </div>

                    <div
                      *ngIf="selectedFeed.variant_entries"
                      class="row mt-4 border-bottom bg-dark text-white"
                    >
                      <div class="col-3">Date</div>
                      <div class="col">Variant</div>
                      <div class="col">Spot</div>
                      <div class="col">Average</div>
                      <div class="col">High</div>
                      <div class="col">Low</div>
                      <div class="col">Tally</div>
                    </div>
                    <div
                      *ngIf="!selectedFeed.variant_entries"
                      class="row mt-4 border-bottom bg-dark text-white"
                    >
                      <div class="col-3">Date</div>
                      <div class="col">Spot</div>
                      <div class="col">Average</div>
                      <div class="col">High</div>
                      <div class="col">Low</div>
                      <div class="col">Tally</div>
                    </div>

                    <div class="row">
                      <div class="col text-center">
                        <new-spinner
                          *ngIf="selectedFeed.fetching"
                          [size]="'sm'"
                        ></new-spinner>
                        <div class="btn-group" *ngIf="!selectedFeed.fetching">
                          <button
                            class="btn btn-primary p-1"
                            (click)="
                              fetchRecent(
                                $event,
                                false,
                                selectedFeed.period,
                                selectedFeed.time_zone,
                                selectedFeed.metric,
                                selectedFeed.field
                              )
                            "
                          >
                            Fetch Newer
                          </button>
                          <button
                            class="btn btn-primary p-1"
                            (click)="
                              fetchRecent(
                                $event,
                                true,
                                selectedFeed.period,
                                selectedFeed.time_zone,
                                selectedFeed.metric,
                                selectedFeed.field
                              )
                            "
                          >
                            <i class="fa fa-plus-circle"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <ng-container *ngIf="selectedFeed.variant_entries">
                      <div
                        class="row border-bottom"
                        *ngFor="let entry of selectedFeed.entries | values"
                      >
                        <div class="col-3">
                          {{ entry.time | date : "short" }}
                        </div>
                        <div class="col">{{ entry.variant }}</div>
                        <div class="col">{{ entry.spot_value }}</div>
                        <div class="col">{{ entry.average_value }}</div>
                        <div class="col">{{ entry.maximum_value }}</div>
                        <div class="col">{{ entry.minimum_value }}</div>
                        <div class="col">{{ entry.tally_value }}</div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="!selectedFeed.variant_entries">
                      <div
                        class="row border-bottom"
                        *ngFor="let entry of selectedFeed.entries | values"
                      >
                        <div class="col-3">
                          {{ entry.time | date : "short" }}
                        </div>
                        <div class="col">
                          {{ entry.spot_value || "Not found" }}
                        </div>
                        <div class="col">{{ entry.average_value }}</div>
                        <div class="col">{{ entry.maximum_value }}</div>
                        <div class="col">{{ entry.minimum_value }}</div>
                        <div class="col">{{ entry.tally_value }}</div>
                      </div>
                    </ng-container>

                    <div class="row mt-2">
                      <div class="col text-center">
                        <new-spinner
                          *ngIf="selectedFeed.fetching"
                          [size]="'sm'"
                        ></new-spinner>
                        <div class="btn-group" *ngIf="!selectedFeed.fetching">
                          <button
                            class="btn btn-primary p-1"
                            (click)="
                              fetch(
                                $event,
                                false,
                                selectedFeed.period,
                                selectedFeed.time_zone,
                                selectedFeed.metric,
                                selectedFeed.field
                              )
                            "
                          >
                            Fetch More|
                            {{
                              selectedFeed.feed_coverage_start | date : "short"
                            }}
                          </button>
                          <button
                            class="btn btn-primary p-1"
                            (click)="
                              fetch(
                                $event,
                                true,
                                selectedFeed.period,
                                selectedFeed.time_zone,
                                selectedFeed.metric,
                                selectedFeed.field
                              )
                            "
                          >
                            <i class="fa fa-plus-circle"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </tab>
                <tab heading="Graph" (selectTab)="onGraphTabSelected()">
                  <div class="row mb-2" *ngIf="entity">
                    <div class="col-12 d-flex flex-wrap align-items-center">
                      <ng-container
                        *ngFor="let source of objectValues(entity.feeds)"
                      >
                        <ng-container
                          *ngTemplateOutlet="
                            graphSource;
                            context: { $implicit: source }
                          "
                        ></ng-container>
                      </ng-container>
                    </div>
                  </div>

                  <div class="col-12 my-3" style="width: 100%;">
                    <div
                      #echartContainer
                      style="width: 100%; height: 580px; min-height: 480px;"
                    ></div>
                  </div>
                </tab>
              </tabset>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!--                                                        -->
    <!--                    Pop-Up Menu                         -->
    <!--                                                        -->
    <ng-template #chartModal>
      <modal-widget
        *ngIf="currentModal"
        (widgetEvent)="eventHandler($event, 'pop-up', chartModal)"
        [entity]="currentModal"
        [layout]="'shadowbox'"
        [options]="{}"
      ></modal-widget>
    </ng-template>
  `,
})
export class ExtendedDeviceChartLogicalWidgetComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("echartContainer", { static: false }) echartContainer: ElementRef;
  public chartInstance: any = null;
  @Input() entity: ExtendedDeviceChartEntity | null = null;
  @Input() templateHint: string = null;
  @Input() options: any = null;
  @Input() layout = "standard";
  @Output() widgetEvent = new EventEmitter<LogicalWidgetEventStruct>();
  forwardEvent(e, widgetEvent: LogicalWidgetEventStruct) {
    e.preventDefault();
    this.widgetEvent.emit(widgetEvent);
  }

  public objectValues = Object.values;

  public LogicalExtendedDeviceWidgetEnum = LogicalExtendedDeviceWidgetEnum;
  public selectedFeed: ChartFeed | null = null;
  public selected = {};
  public chart_type = "line";
  public chart_data: Array<any> = [
    { data: [1, 2, 3, 4, 5, 6, 5, 4, 3, 2, 1], label: "loading" },
  ];
  public chart_labels: Array<any> = ["loading"];
  public chart_options: any = { responsive: true, maintainAspectRatio: false };
  public chart_legend = false;
  public modalRef: BsModalRef;
  public currentModal: any = null;
  public time_period = "ai.ticks.1";
  public time_options = [
    { value: "ai.ticks.1", text: "Plot" },
    { value: "ai.minutes.1", text: "1 Minute" },
    { value: "ai.minutes.5", text: "5 Minute" },
    { value: "ai.minutes.15", text: "15 Minute" },
    { value: "ai.minutes.30", text: "30 Minute" },
    { value: "ai.hours.1", text: "1 Hour" },
    { value: "ai.days.1", text: "1 Day" },
    { value: "ai.weeks.1", text: "1 Week" },
    { value: "ai.months.1", text: "1 Month" },
    { value: "ai.years.1", text: "1 Year" },
  ];

  public time_zone = "America/Chicago";
  public time_zone_options = [
    { value: "America/Chicago", text: "America/Chicago" },
    { value: "Pacific/Honolulu", text: "America/Honolulu" },
    { value: "America/Anchorage", text: "America/Anchorage" },
    { value: "America/Los_Angeles", text: "America/Los_Angeles" },
    { value: "America/Denver", text: "America/Denver" },
    { value: "America/New_York", text: "America/Chicago" },
    { value: "Asia/Bangkok", text: "Asia/Bangkok" },
    { value: "Europe/Berlin", text: "Europe/Berlin" },
    { value: "Europe/Paris", text: "Europe/Paris" },
    { value: "Asia/Chongqing", text: "Asia/Chongqing" },
  ];

  public for_field = null;
  public metric_units = false;
  public field_options = [];
  public range_selected = false;

  constructor(
    public toasterService: ToasterService,
    public modalService: BsModalService
  ) { }

  eventHandler(event, field, modal) {
    console.log("Release Unhandled Event", field, event);
  }

  showModal(current, modal, clickOut = false, customClass = "") {
    this.currentModal = current;
    if (!clickOut) {
      let config: ModalOptions = {
        backdrop: "static",
        keyboard: false,
        class: customClass,
      };
      this.currentModal.modalRef = this.modalService.show(modal, config);
    } else {
      let config: ModalOptions = {
        class: customClass,
      };
      this.currentModal.modalRef = this.modalService.show(modal, config);
    }
  }

  addRange(e) {
    e.preventDefault();
    this.entity
      .fetchFeed(
        this.time_period,
        this.time_zone,
        this.metric_units,
        this.for_field
      )
      .then((feed: ChartFeed) => {
        this.selectedFeed = feed;
        this.range_selected = true;
        this.selected[feed.key] = true;
        this.buildGraph();
      });
  }

  customRange(e, modal) {
    let to = new Date();
    let from = new Date(to.getTime() - 24 * 60 * 60 * 1000);
    let time_range = new DateTimeIntervalEntity(from, to);
    let dialog = new ModalWidget(
      `Pull Range`,
      ModalWidgetEnum.MODAL_WIDGET__CONFIRM,
      time_range,
      { edit: true },
      "shadowbox",
      time_range.overrides()
    );
    this.showModal(dialog, modal, false, "md-modal");
    time_range.promise
      .then((r) => {
        this.entity
          .fetchFeed(
            this.time_period,
            this.time_zone,
            this.metric_units,
            this.for_field,
            { from: r.from, to: r.to }
          )
          .then((feed: ChartFeed) => {
            this.selectedFeed = feed;
            this.range_selected = true;
            this.selected[feed.key] = true;
            this.buildGraph();
          });
      })
      .catch(() => {
        // swallow
      });
  }

  public chartClicked(e: any): void {
    // console.log(e);
  }

  public chartHovered(e: any): void {
    // console.log(e);
  }

  select(e, key) {
    e.preventDefault();
    this.selectedFeed = this.entity.feeds[key];
  }

  remove(e, key) {
    e.preventDefault();
    if (this.selectedFeed && this.selectedFeed.key == key) {
      this.selectedFeed = null;
    }
    delete this.entity.feeds[key];
    this.selected[key] = false;
    this.buildGraph();
  }

  private resizeObserver: any = null;

  ngAfterViewInit() {
    this.setupResizeObserver();
    setTimeout(() => {
      this.initEchart();
    }, 150);
  }

  private setupResizeObserver() {
    const RO =
      typeof window !== "undefined" &&
      ((window as any).ResizeObserver || ResizeObserver);
    if (
      RO &&
      this.echartContainer &&
      this.echartContainer.nativeElement
    ) {
      this.resizeObserver = new RO((entries: any) => {
        for (let entry of entries) {
          if (entry.contentRect && entry.contentRect.width > 50) {
            if (!this.chartInstance) {
              this.initEchart();
            } else {
              this.chartInstance.resize();
            }
          }
        }
      });
      this.resizeObserver.observe(this.echartContainer.nativeElement);
    }
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  }

  @HostListener("window:resize")
  onWindowResize() {
    if (this.chartInstance) {
      this.chartInstance.resize();
    }
  }

  public onGraphTabSelected() {
    setTimeout(() => {
      this.initEchart();
      if (this.chartInstance) {
        this.chartInstance.resize();
        this.renderEchart();
      }
    }, 150);
  }

  public initEchart() {
    if (!this.echartContainer || !this.echartContainer.nativeElement) {
      return;
    }
    const width = this.echartContainer.nativeElement.clientWidth;
    if (width <= 0) {
      return;
    }
    if (!this.chartInstance) {
      this.chartInstance = echarts.init(this.echartContainer.nativeElement);
    } else {
      this.chartInstance.resize();
    }
    this.renderEchart();
  }

  public toggleGraph(e, key) {
    e.preventDefault();
    this.selected[key] = !(this.selected[key] || false);
    this.buildGraph();
  }

  public buildGraph() {
    this.renderEchart();
  }

  public renderEchart() {
    if (!this.chartInstance) {
      this.initEchart();
      if (!this.chartInstance) return;
    }

    const series = [];
    const legendData = [];
    const feedUnits: string[] = [];

    for (let k in this.selected) {
      if (
        this.selected[k] &&
        this.entity &&
        this.entity.feeds &&
        this.entity.feeds[k]
      ) {
        let feed = this.entity.feeds[k];
        let u = feed.units || feed.field || "Value";
        if (!feedUnits.includes(u)) {
          feedUnits.push(u);
        }
      }
    }

    for (let k in this.selected) {
      if (
        this.selected[k] &&
        this.entity &&
        this.entity.feeds &&
        this.entity.feeds[k]
      ) {
        let feed = this.entity.feeds[k];
        let periodObj = this.time_options.find((t) => t.value === feed.period);
        let periodLabel = periodObj ? periodObj.text : feed.period;
        let name = `${feed.field} (${periodLabel})`;
        let u = feed.units || feed.field || "Value";
        let yAxisIndex = feedUnits.indexOf(u) >= 1 ? 1 : 0;

        let sortedEntries = [...(feed.entries || [])].sort(
          (a, b) =>
            (a.time ? new Date(a.time).getTime() : 0) -
            (b.time ? new Date(b.time).getTime() : 0)
        );

        if (feed.variant_entries) {
          const variantMap = new Map<string, any[]>();
          for (let entry of sortedEntries) {
            if (!entry.time) continue;
            let vKey = entry.variant || "Default";
            if (!variantMap.has(vKey)) {
              variantMap.set(vKey, []);
            }
            let val =
              entry.spot_value !== null && entry.spot_value !== undefined
                ? entry.spot_value
                : entry.average_value !== null &&
                  entry.average_value !== undefined
                  ? entry.average_value
                  : entry.tally_value !== null && entry.tally_value !== undefined
                    ? entry.tally_value
                    : null;
            variantMap.get(vKey).push([new Date(entry.time).getTime(), val]);
          }

          variantMap.forEach((points, variant) => {
            const seriesName = `${name} (${variant})`;
            legendData.push(seriesName);
            series.push({
              name: seriesName,
              type: "line",
              smooth: true,
              yAxisIndex: yAxisIndex,
              showSymbol: points.length < 50,
              symbolSize: 4,
              data: points,
            });
          });
        } else {
          legendData.push(name);
          let dataPoints = [];
          for (let i = 0; i < sortedEntries.length; i++) {
            let entry = sortedEntries[i];
            if (!entry.time) continue;
            let val =
              entry.spot_value !== null && entry.spot_value !== undefined
                ? entry.spot_value
                : entry.average_value !== null &&
                  entry.average_value !== undefined
                  ? entry.average_value
                  : entry.tally_value !== null && entry.tally_value !== undefined
                    ? entry.tally_value
                    : null;
            dataPoints.push([new Date(entry.time).getTime(), val]);
          }

          series.push({
            name: name,
            type: "line",
            smooth: true,
            yAxisIndex: yAxisIndex,
            showSymbol: dataPoints.length < 50,
            symbolSize: 4,
            data: dataPoints,
          });
        }
      }
    }

    const totalPoints = series.reduce(
      (acc, s) => acc + (s.data ? s.data.length : 0),
      0
    );
    const hasData = totalPoints > 0;
    const now = new Date();
    const twentyFourHoursAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000);

    const yAxisConfig: any =
      feedUnits.length >= 2
        ? [
            {
              type: "value",
              name: feedUnits[0],
              position: "left",
              scale: true,
              nameLocation: "end",
              nameGap: 16,
              nameTextStyle: {
                padding: [0, 0, 10, 0],
                fontSize: 12,
                fontWeight: "bold",
                color: "#475569",
              },
              axisLabel: {
                formatter: (val: number) => Math.round(val * 100) / 100,
              },
            },
            {
              type: "value",
              name: feedUnits[1],
              position: "right",
              scale: true,
              splitLine: { show: false },
              nameLocation: "end",
              nameGap: 16,
              nameTextStyle: {
                padding: [0, 0, 10, 0],
                fontSize: 12,
                fontWeight: "bold",
                color: "#475569",
              },
              axisLabel: {
                formatter: (val: number) => Math.round(val * 100) / 100,
              },
            },
          ]
        : [
            {
              type: "value",
              name: feedUnits[0] || "",
              scale: true,
              nameLocation: "end",
              nameGap: 16,
              nameTextStyle: {
                padding: [0, 0, 10, 0],
                fontSize: 12,
                fontWeight: "bold",
                color: "#475569",
              },
              axisLabel: {
                formatter: (val: number) => Math.round(val * 100) / 100,
              },
            },
          ];

    const option: any = {
      title: {
        text: "Plot",
        subtext: hasData
          ? undefined
          : series.length > 0
            ? "No data returned for selected feed/range"
            : "Select a feed button above to display data",
        left: "center",
        top: 0,
        textStyle: { fontSize: 16, color: "#333" },
        subtextStyle: { fontSize: 13, color: "#888" },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "cross" },
        formatter: (params: any) => {
          if (!params || !params.length) return "";
          const firstTime = params[0].value ? params[0].value[0] : null;
          let dateStr = firstTime ? new Date(firstTime).toLocaleString() : "";
          let res = `<div style="font-weight:bold;margin-bottom:4px;">${dateStr}</div>`;
          for (let p of params) {
            let val = p.value ? p.value[1] : null;
            let displayVal =
              val !== null && val !== undefined
                ? typeof val === "number"
                  ? Math.round(val * 100) / 100
                  : val
                : "N/A";
            res += `<div style="display:flex;align-items:center;margin:2px 0;">
              <span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:${p.color};margin-right:6px;"></span>
              <span style="margin-right:8px;">${p.seriesName}:</span>
              <strong style="margin-left:auto;">${displayVal}</strong>
            </div>`;
          }
          return res;
        },
      },
      legend: {
        data: legendData,
        top: 36,
        left: "center",
        width: "85%",
        type: "scroll",
      },
      grid: {
        left: 75,
        right: feedUnits.length >= 2 ? 75 : 40,
        bottom: 85,
        top: 140,
        containLabel: true,
      },
      toolbox: {
        right: 20,
        top: 0,
        feature: {
          dataZoom: { yAxisIndex: "none" },
          restore: {},
          saveAsImage: {},
        },
      },
      dataZoom: [
        {
          type: "slider",
          start: 0,
          end: 100,
          bottom: 12,
        },
        {
          type: "inside",
        },
      ],
      xAxis: {
        type: "time",
        boundaryGap: false,
        min: hasData ? undefined : twentyFourHoursAgo,
        max: hasData ? undefined : now,
      },
      yAxis: yAxisConfig,
      series: series,
    };

    this.chartInstance.setOption(option, true);
  }

  public fetchRecent(e, more, time_period, time_zone, metric, for_field) {
    e.preventDefault();
    this.entity
      .fetchFeed(time_period, time_zone, metric, for_field, {
        recent: true,
        more: more,
      })
      .then(() => {
        this.buildGraph();
      });
  }

  public fetch(e, more, time_period, time_zone, metric, for_field) {
    e.preventDefault();
    this.entity
      .fetchFeed(time_period, time_zone, metric, for_field, {
        more: more,
      })
      .then(() => {
        this.buildGraph();
      });
  }

  public fetchAndRefresh(e, key) {
    e.preventDefault();
    let feed = this.entity.feeds[key];
    this.entity
      .fetchFeed(feed.period, feed.time_zone, feed.metric, feed.field, {
        more: true,
      })
      .then(() =>
        this.entity
          .fetchFeed(feed.period, feed.time_zone, feed.metric, feed.field, {
            recent: true,
          })
          .then(() => {
            this.buildGraph();
          })
      );
  }

  ngOnInit() {
    if (
      this.entity &&
      this.entity.device_type &&
      this.entity.device_type.fields
    ) {
      this.field_options = [];
      for (let key of Object.keys(this.entity.device_type.fields)) {
        if (key != "notSupported" && key != "NotSupported") {
          if (!this.for_field) this.for_field = key;
          this.field_options.push({ value: key, text: key });
        }
      }
    }
  }
}
